// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tti-zenith/list',
    name: 'tii-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/TTI.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nomenclators_tti',
    },
  },
]

export default formTable
